/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilieraPermissionDTO
 */
export interface FilieraPermissionDTO {
    /**
     * 
     * @type {string}
     * @memberof FilieraPermissionDTO
     */
    filieraPermissionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilieraPermissionDTO
     */
    description?: string | null;
}

/**
 * Check if a given object implements the FilieraPermissionDTO interface.
 */
export function instanceOfFilieraPermissionDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FilieraPermissionDTOFromJSON(json: any): FilieraPermissionDTO {
    return FilieraPermissionDTOFromJSONTyped(json, false);
}

export function FilieraPermissionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilieraPermissionDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filieraPermissionId': !exists(json, 'filieraPermissionId') ? undefined : json['filieraPermissionId'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function FilieraPermissionDTOToJSON(value?: FilieraPermissionDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filieraPermissionId': value.filieraPermissionId,
        'description': value.description,
    };
}

